import { Locale } from 'src/types'

import { getSelectFields } from 'src/pages/ServiceMaintenance/helpers'
import { FullMaintenanceProps } from 'src/api/Maintenance/types'

export function getLastMaintenanceInfo(
  locale: Locale['maintenance'],
  history?: FullMaintenanceProps[],
): string {
  if (!history || !history.length) return ''

  const [lastMaintenanceInfo] = history.sort(
    (a, b) => b.date.seconds - a.date.seconds,
  )

  const listOfServiceType = getSelectFields(locale)

  const title = listOfServiceType.find(
    item => item.value === lastMaintenanceInfo.serviceType,
  )?.placeholder

  return `${title}: ${lastMaintenanceInfo.details}`
}
